<template>
  <div class="of-box">
    <div class="of-container is-vertical">
      <div class="of-aside base-search-box">
        <div class="of-filter clearfix">
          <div class="filter-left">
            <el-button v-access:add type="primary" size="small" icon="fa fa-plus"
              @click="EditView()">新增报告</el-button>
          </div>
          <div class="filter-right">
          </div>
        </div>
      </div>
      <div ref="tableBox" class="of-main no-scroll">
        <div class="of-table">
          <el-table v-loading="isloading" border stripe resizable :data="listData"
            style="width: 100%" size="small" :max-height="pageHeight" :height="pageHeight"
            :header-cell-style="{ background: '#f2f3f5' }" tooltip-effect>
            <el-table-column type="index" label="序号" width="50">
            </el-table-column>
            <el-table-column v-for="(item, index) in tableCols" :key="index" :prop="item.prop"
              :label="item.label" :width="item.width" header-align="left" :align="item.align">

              <template slot-scope="scope">
                <el-tooltip v-if="item.showtip" :content="`${scope.row[item.prop]}`"
                  placement="bottom" effect="light">
                  <span>{{ scope.row[item.prop] }}</span>
                </el-tooltip>
                <span v-else>{{ scope.row[item.prop] }}</span>
              </template>
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="260">
              <template slot-scope="scope">
                <el-button class="table-ctrlbtn" style="margin-right: 8px;" size="small"
                  @click="showView(scope.row)">详情</el-button>
                <el-button class="table-ctrlbtn" style="margin-right: 8px;" size="small"
                  icon="el-icon-edit" @click="EditView(scope.row)">重新生成</el-button>
                <!-- <el-button
                  class="table-ctrlbtn"
                  style="margin-right: 8px;"
                  size="small"
                  icon="el-icon-edit"
                  @click="EditView(scope.row)"
                >导出</el-button> -->
                <el-button class="table-ctrlbtn" style="margin-right: 8px;" size="small"
                  icon="el-icon-delete" @click="DelView(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="of-aside">
        <my-pagination :total="total" :pageSize="pageQuery.pageSize"
          :pageIndex="pageQuery.pageIndex" @change="pageChange"></my-pagination>
      </div>
    </div>
    <my-drawer :visible="editshow" :title="myForm.title" size="90%" cancelName="关 闭" submitName=""
      :isSubmit="isSubmit" @onCancel="editshow = false">
      <makePage v-if="editshow" :mform="myForm.form" :serId="serId" slot="content"
        @initload="loadPageData">
      </makePage>
    </my-drawer>

    <my-drawer :visible="detailshow" :title="myForm.title" size="90%" cancelName="关 闭" submitName=""
      @onCancel="detailshow = false">
      <detailPage v-if="detailshow" :mform="myForm.form" :serId="serId" slot="content"
        @initload="loadPageData">
      </detailPage>
      <span slot="footer" clas="dialog-footer">
        <!-- <el-button
          v-loading="exportLoading"
          type="primary"
          size="small"
          @click="exportData"
        >导 出</el-button> -->
        <el-button size="small" @click="detailshow = false">关 闭</el-button>
      </span>
    </my-drawer>
  </div>
</template>
<script>
import { getMakeList, setMakeDel, exportResult } from '@/modules/contract/api/freightnew.js'
import MyPagination from "@/components/pagination"
import MyDrawer from '@/components/drawer'
import makePage from './report/make'
import detailPage from './report/detail/index'
export default {
  name: 'DModelPage',
  components: {
    MyPagination,
    MyDrawer,
    makePage,
    detailPage
  },
  props: {
    node:{
      type: Object,
      default: ()=>{
        return {}
      }
    }
  },
  data () {
    return {
      pageQuery: {
        pageSize: 50,
        pageIndex: 1,
        sortOrder: 'desc',
        sortField: 'CreateDate',
        fastSearchFields: 'ModelName,TrainItems,VehicleItems',
        fastSearchKeyWord: '',
        SerId: '',
        ContractId: '',
        RecordId: '',
      },
      detailshow: false,
      pageHeight: 500,
      total: 0,
      tableCols: [
        { label: '报告名称', prop: 'Title', width: '150', type: '', sortable: true, showtip: true },
        { label: '开始时间', prop: 'DataStartDate', width: '100', type: '', showtip: true },
        { label: '结束时间', prop: 'DataEndDate', width: '100', type: '', showtip: true },
        { label: '归属月份', prop: 'MonthDate', width: '100', type: '', showtip: true },
        // { label: '计费规则名称', prop: 'PriceTempName', width: '100', type: '', showtip: true },
        { label: '设备配置', prop: 'DataVehicleItems', width: '300', type: '', showtip: true },
        { label: '固定费用类型', prop: 'FixedCostType', width: '100', type: '', showtip: true },
        { label: '固定费用', prop: 'FixedCost', width: '100', type: '', showtip: true },
        { label: '创建人', prop: 'CreatorName', width: '100', type: '', sortable: true },
        { label: '创建时间', prop: 'CreateDate', width: '150', type: '', sortable: true },
      ],
      myForm: {
        title: "新增轮胎",
        form: {},
      },
      isSubmit: false,
      editshow: false,
      isloading: false,
      listData: [],
      exportLoading: false,
    }

  },
  computed: {},
  mounted () {
     setTimeout(()=> {
    this.pageQuery.SerId = this.node.ServiceId
    this.pageQuery.ContractId = this.node.ContractId
    this.loadPageData()
    },200)
    this.mixinTableHeight(0)
  },
  methods: {
    loadPageData () {
      this.isloading = true
      getMakeList(this.pageQuery).then(res => {
        this.isloading = false
        if (res.data.Code === 0) {
          this.listData = res.data.Data.rows.map(p => {
            return {
              ...p,
              DataStartDate: this.datetime(p.DataStartDate, 'YYYY-MM-DD'),
              DataEndDate: this.datetime(p.DataEndDate, 'YYYY-MM-DD'),
              MonthDate: this.datetime(p.MonthDate, 'YYYY-MM'),
              FixedCost: p.FixedCost == 0 ? '' : p.FixedCost
            }
          })
          this.total = res.data.Data.total
        }
      })
    },
    EditView (row) {
      this.isSubmit = false
      if (row && row.Id) {
        this.myForm.title = "重新生成运费报告"
        this.myForm.form = row
      } else {
        this.myForm.title = "生成运费报告"
        this.myForm.form = { ServiceId: this.serId, ContractId: this.contractId, ReportType: '结算' }
      }
      this.editshow = true
    },
    showView (row) {
      this.isSubmit = false
      if (row && row.Id) {
        this.myForm.title = "运费报告详情"
        this.myForm.form = row
        this.detailshow = true
      }
    },
    editSubmit () {
      this.isSubmit = true
      this.$refs.MDPage.submit()
    },
    finishEdit () {
      this.editshow = false
      this.loadPageData()
    },
    pageChange (pindex, psize) {
      this.pageQuery.pageSize = psize
      this.pageQuery.pageIndex = pindex
      this.loadPageData()
    },
    DelView (row) {
      let _this = this
      this.$confirm('确定删除该数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        setMakeDel({ Id: row.Id }).then(res => {
          if (res.data.Code === 0) {
            _this.toast({ content: '删除成功', type: 'success' })
            _this.loadPageData()
          }
        })
      })
    },
    exportData () {
      this.exportLoading = true
      exportResult(this.myForm.form.Id).then(res => {
        this.exportLoading = false
        if (res.data.Code === 0) {
          window.open(`/common/CommonTemplateDown/DownExportFile?ft=189&&id=${res.data.Data}`)
        }
      })
    }
  }
}
</script>

<style></style>
